<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="8">
        <h2 class="display-1 font-weight-bold mb-5">Client Login Area</h2>
        <p class="ma-4 text-justify body-2">
          Want to checkout your instance details? Drop your email address and we will have it
          delivered directly to your inbox
        </p>
        <custom-form action="/api/v1/clients/profile" @submitted="onSubmitted">
          <custom-input name="email" label="Email Address" prepend-inner-icon="mdi-email-outline" />
          <custom-button color="primary" block large raised tile>Request Login Link </custom-button>
        </custom-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  methods: {
    onSubmitted(response) {
      window.Notify.success(response.message, { close: true });
    },
  },
};
</script>
